import React from 'react';
import { useTranslation } from 'react-i18next';

import { Notification, NotificationStatus } from '@cp-shared-10/frontend-ui';

export type NoConnectionNotificationProps = {
    testId?: string;
};

export const NoConnectionNotification: React.FC<NoConnectionNotificationProps> = ({ testId }) => {
    const { t } = useTranslation();
    return <Notification status={NotificationStatus.error} text={t('error.no-connection.text')} testId={testId} />;
};
